import { getLiveDatabaseSizeMetrics } from '@databases/analytics';

import type { CanvasMetadata } from '@canvas/frontend-metrics';

/**
 * Builds database size metadata (entriesCount, fieldsCount) for metric reporting.
 *
 * Reads live entry/field counts from the collab `YDatabase` when a `contentId` is present.
 * Returns an empty object if no contentId or data unavailable.
 *
 * Callers must pass `contentId` on stabilized metric metadata (`FireParams.metadata`) when
 * firing if they want these fields merged into reliability payloads.
 */
export function buildDatabaseSizeMetadata(context?: CanvasMetadata): CanvasMetadata {
  const contentId =
    context && typeof context.contentId === 'string' ? context.contentId : undefined;

  const size = contentId ? getLiveDatabaseSizeMetrics(contentId) : undefined;
  const meta: Record<string, number> = {};

  if (size?.entriesCount) {
    meta.entriesCount = size.entriesCount;
  }

  if (size?.fieldsCount) {
    meta.fieldsCount = size.fieldsCount;
  }

  return meta;
}
